import { Logo, Text } from '@feast-it/ui/light';
import React, { ReactElement } from 'react';

import { Area, LogoWrapper, StyledLink } from '../Footer.styled';
import { PATHS } from '../../../constants/paths';
import { useIsDarkTheme } from '../../../context/DarkThemeContext';

export function LogoComponent(): ReactElement {
  const year: number = new Date().getFullYear();
  const isDark = useIsDarkTheme();

  return (
    <Area name="copyright" isDark={isDark}>
      <LogoWrapper>
        <StyledLink href={PATHS.home} aria-label="Go to homepage">
          <Logo name="Togather" width="50%" fill={isDark ? 'white' : 'black'} />
        </StyledLink>
      </LogoWrapper>

      <Text style="bodyExtraSmall" color={isDark ? 'white' : 'darkGrey'}>
        &copy; {year} Karamu Limited trading as Togather.
        All&nbsp;rights&nbsp;reserved.
      </Text>
    </Area>
  );
}
